import React from "react";
import { Navigate, Route, Routes } from "react-router-dom";
import { RoutesPaths } from "./Constant";
import Landing from "../Pages/Landing";
import PrivacyPolicy from "../Pages/PrivacyPolicy";
import TermsConditions from "../Pages/TermsConditions";
import Notfound from "../Components/Notfound";
import AccountClose from "../Pages/AccountClose";

export default function RouteComponent() {
  return ( 
    <>
      <Routes>
        <Route exact path={RoutesPaths.LANDING} element={<Landing />} />
        <Route exact path={RoutesPaths.PRIVACYPOLICY} element={<PrivacyPolicy />} />
        <Route exact path={RoutesPaths.TERMSCONDITIONS} element={<TermsConditions />} />
        <Route exact path={RoutesPaths.NOTFOUND} element={<Notfound />} />
        <Route exact path={RoutesPaths.ACCOUNTCLOSE} element={<AccountClose />} />
        <Route path="*" element={<Navigate to={RoutesPaths.NOTFOUND} />} />
      </Routes>
    </>
  );
}
